import React from "react";
import Drawer from "@material-ui/core/Drawer";
import RightPanel from "./RightPanel";
import style from "./photoWidgetV2.module.css";
import {
  Button,
  ThemeProvider,
  creatorToolTheme,
} from "@my-scoot/component-library-legacy";
import AddAPhoto from "@material-ui/icons/AddAPhoto";
import CameraAlt from "@material-ui/icons/CameraAlt";
import constants from "constants/constants";
import { useNotifications } from "utils/hooks";
import { is_empty } from "utils/validations";
import classnames from "classnames";

const DEFAULT_IMAGE = constants.default_schedule_image;
const MERCHANDISE_DEFAULT =
  "https://images.unsplash.com/photo-1462392246754-28dfa2df8e6b?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8OHx8c3RvcmV8ZW58MHx8MHx8&auto=format&fit=crop&w=1470&q=80";

export default function PhotoWidgetV2({
  buttonText,
  height,
  width,
  className,
  query,
  onChange,
  selected,
  showButton = true,
  showHoverButton = false,
  scheduleType,
  aspect,
  disabled,
  defaultPlaceholderImg,
  maxSizeConstraints = {},
  placeHolderClickable = false,
  uploadViaOptimization = false,
  sectionName,
  showRemoveButton = false,
  open = undefined,
  onOpenChange = undefined,
}) {
  const { notify } = useNotifications();
  const isControlled = typeof open === "boolean";
  const [showRightPanelState, setShowRightPanelState] = React.useState(false);
  const showRightPanel = isControlled ? open : showRightPanelState;
  const setShowRightPanel = (next) => {
    if (isControlled) {
      if (onOpenChange) onOpenChange(next);
    } else {
      setShowRightPanelState(next);
    }
  };

  const checkImageSizeExceeds = (e) => {
    if (e.target.files[0].size > maxSizeConstraints.value) {
      notify(
        `Error: File size is greater than ${maxSizeConstraints.label}`,
        "error"
      );
      setShowRightPanel(false);
      return true;
    } else return false;
  };

  const checkImageSizeExceedsWithConstarints = !is_empty(maxSizeConstraints)
    ? checkImageSizeExceeds
    : () => {};
  const defaultPlaceholder =
    defaultPlaceholderImg ||
    (selected || scheduleType === constants.scheduleTypesId.merchandise
      ? MERCHANDISE_DEFAULT
      : DEFAULT_IMAGE);
  const [crop] = React.useState({
    unit: "%",
    aspect,
    width: 100,
    ...(aspect ? {} : { height: 100 }),
  });

  const handleClick = () => setShowRightPanel(!showRightPanel);

  const handleRemove = (e) => {
    e.stopPropagation();
    onChange(null);
  };

  return (
    <ThemeProvider theme={creatorToolTheme}>
      <div className={className}>
        <div
          className={classnames(
            style.photoWidgetImageHolder,
            placeHolderClickable && style.placeHolderClickableStyle,
            disabled && style.disabledStyle,
            "tw-relative tw-group"
          )}
          style={{
            backgroundImage: `url("${selected || defaultPlaceholder}")`,
            height: height,
            width: width,
          }}
          {...(placeHolderClickable && { onClick: handleClick })}
        >
          {showHoverButton && (
            <>
              <div className="tw-absolute tw-inset-0 tw-bg-black tw-transition-opacity tw-duration-200 tw-opacity-0 group-hover:tw-opacity-10" />
              <div className="tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center tw-pointer-events-none tw-opacity-0 group-hover:tw-opacity-100 tw-transition-opacity tw-duration-200">
                <div
                  onClick={handleClick}
                  className="tw-pointer-events-auto tw-cursor-pointer tw-h-[36px] tw-w-[36px] tw-rounded-full tw-bg-white tw-flex tw-items-center tw-justify-center"
                >
                  <CameraAlt />
                </div>
              </div>
            </>
          )}
          {selected && showRemoveButton && (
            <div
              onClick={handleRemove}
              className="tw-absolute tw-top-0 tw-right-0 tw-w-full tw-h-full tw-bg-white tw-items-center tw-justify-center tw-text-red-700 tw-text-xs tw-flex tw-opacity-0 hover:tw-opacity-80"
            >
              Remove
            </div>
          )}
          {showButton && (
            <Button
              color="subtleSecondary"
              size="thin"
              onClick={handleClick}
              className="d-flex align-items-center text-dark"
              disabled={disabled}
            >
              <AddAPhoto className="mr-2" /> {buttonText}
            </Button>
          )}
        </div>
      </div>

      {showRightPanel && (
        <Drawer
          open
          anchor="right"
          // ref={this.ref}
          variant="temporary"
          onEscapeKeyDown={() => setShowRightPanel(false)}
          onBackdropClick={() => setShowRightPanel(false)}
        >
          <RightPanel
            query={query}
            minWidth={height}
            minHeight={width}
            id="photo"
            radius={3}
            crop={crop}
            getUrl={(url) => {
              onChange(url);
              setShowRightPanel(false);
            }}
            checkImageSizeExceeds={checkImageSizeExceedsWithConstarints}
            uploadViaOptimization={uploadViaOptimization}
            sectionName={sectionName}
          />
        </Drawer>
      )}
    </ThemeProvider>
  );
}

PhotoWidgetV2.defaultProps = {
  buttonText: "Change Photo",
  query: "mountains",
  onChange: () => {},
  sectionName: "",
};
